import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    data: null,
    error: "",
};

const sandboxErrorSlice = createSlice({
    name: "sandboxError",
    initialState,
    reducers: {
        setSandboxError: (state, action) => {
            state.data = action.payload;
        },
        clearSandboxError: (state) => {
            state.data = null;
        },
    },
});

export const { setSandboxError, clearSandboxError } = sandboxErrorSlice.actions;
export default sandboxErrorSlice.reducer;
